import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { Transition } from "../../../components/Transition";
import { useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import CohortService from "../../../services/CohortService";
import auth from "../../../services/auth";
import Loader from "../../../components/loader";
import EmailInvitationBody from "../../../components/EmailInvitationBody";
import EmailPreview from "../../../components/EmailPreview";
import { parseAndValidateEmails, emailBodyText } from "../../../utils/utils";

const AddAssignment = ({
  open,
  handleClose,
  cohort,
  loadDataByCohortIdByPagination,
}) => {
  const [nonSimAssignment, setNonSimAssignment] = useState({
    assignment: "",
    progressNotes: "",
  });
  const [loading, setLoading] = useState(false);
  const [participantEmails, setParticipantsEmails] = useState("");
  const [mailBody, setEmailBody] = useState(emailBodyText);
  const [emailList, setEmailList] = useState([]);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");

  let user = auth.getUserDetails();
  const accId = user.accId;

  const [, forceUpdate] = useState(0);
  const simpleValidator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const handleEditorChange = (content, editor) => {
    setEmailBody(content);
  };

  const handleInputChange = (e) => {
    const newState = { [e.target.name]: e.target.value };
    setNonSimAssignment((prevState) => ({ ...prevState, ...newState }));
  };

  useEffect(() => {
    getCohortParticipantsEmail();
  }, []);

  const getCohortParticipantsEmail = async () => {
    setLoading(true);
    try {
      const response = await CohortService().getCohortParticipantsEmail(
        cohort.value
      );
      if (response?.data?.data) {
        setParticipantsEmails(response?.data?.data);
        onEmailChange(response?.data?.data);
      }
    } catch (error) {
      console.error("Error retreiving cohort participant's email.", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = (event) => {
    var emailsData = event.target.value;
    setParticipantsEmails(emailsData);
    setEmailErrorMessage("");
    onEmailChange(emailsData);
  };

  const onEmailChange = (emailsData) => {
    const { validEmails, error } = parseAndValidateEmails(emailsData);

    if (error) {
      setEmailErrorMessage(error);
      return;
    }

    setEmailList(validEmails);
  };

  const saveAssignment = async (e) => {
    setLoading(true);
    if (simpleValidator.current.allValid()) {
      const params = {
        cohortId: cohort.value,
        accountId: accId,
        assignment: nonSimAssignment.assignment,
        progressNotes: nonSimAssignment.progressNotes,
        emailTemplate: mailBody,
        emailList: Array.from(new Set(emailList)),
        senderName: user.firstName + " " + user.lastName,
      };
      await CohortService().assignAssignmentToCohort(params);
      loadDataByCohortIdByPagination();
      handleClose();
    } else {
      simpleValidator.current.showMessages();
    }
    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      maxWidth="md"
      fullWidth
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Add Assignment</DialogTitle>
      <DialogContent>
        <form className="form-horizontal" noValidate={true}>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label content-body">
              Cohort Name
            </label>
            <div className="col-sm-9">
              <input
                name="name"
                type="text"
                defaultValue={cohort.label}
                className="form-control form-control-success fields-font"
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label required label">
              Assignments
            </label>
            <div className="col-sm-9 fields-font">
              <textarea
                name="assignment"
                rows={5}
                maxLength={1000}
                placeholder="Assignments"
                className="form-control form-control-success fields-font"
                value={nonSimAssignment.assignment}
                onChange={handleInputChange}
              />
              {simpleValidator.current.message(
                "Assignment",
                nonSimAssignment.assignment,
                "required"
              )}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label label">
              Progress Notes
            </label>
            <div className="col-sm-9">
              <input
                name="progressNotes"
                type="text"
                maxLength={500}
                placeholder="Progress Notes"
                className="form-control form-control-success fields-font"
                value={nonSimAssignment.progressNotes}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-3 form-control-label required label">
              Email Addresses
            </label>
            <div className="col-sm-9">
              <textarea
                name="emails"
                rows={5}
                id="emails"
                placeholder="Emails"
                className="form-control form-control-success fields-font"
                onChange={handleEmailChange}
                value={participantEmails}
              />
              {emailErrorMessage != "" && (
                <span className="error">{emailErrorMessage}</span>
              )}
            </div>
          </div>

          <EmailInvitationBody
            emailBody={mailBody}
            handleEditorChange={handleEditorChange}
          />

          <div className="form-group row">
            <div className="col-sm-9 offset-sm-3">
              <button
                type="button"
                onClick={saveAssignment}
                className="btn btn-submit float-right buttons"
                disabled={
                  participantEmails.trim() === "" || emailErrorMessage !== ""
                }
              >
                Add Assignment
              </button>
              <button
                type="button"
                className="btn btn-cancel float-right buttons"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </div>
          <EmailPreview mailBody={mailBody} />
        </form>
        {loading && <Loader loading={loading} />}
      </DialogContent>
    </Dialog>
  );
};

export default AddAssignment;
